import {Component, ElementRef, ViewChild, OnInit} from '@angular/core';
import {IonicPage, NavController, PopoverController, ViewController, App} from 'ionic-angular';
import {CorePage} from '../../shared/interfaces/corePage.interface';
import {OauthService} from '../../shared/services/oauth.service';
import {LocalStorageService} from '../../shared/services/localStorage.service';
import * as moment from 'moment';
import {LoadingService} from '../../shared/services/loading.service';
import {Subject} from 'rxjs/Subject';
import {Search} from '../../shared/models/search/search.model';
import {SondageListComponent} from '../../core/sondage-list/sondage-list.component';
import {PlatformContextService, BeneficiaireContextService} from '../../shared/services/context';
import {PushService} from '../../shared/services/push.service';
import { UserStorageService } from '../../shared';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageService } from '../../shared/services/message.service';
import { Beneficiaire } from '../../shared/models/beneficiaire/beneficiaire.model';
import { BeneficiairesService } from '../../shared/services/beneficiaires.service';
import { ResponseMessage } from '../../shared/models/responseMessage/responseMessage.model';
import { ToastDirective } from '../../shared/directives/toast/toast';
import { LostPasswordService } from '../lost-password/services/lost-password.service';
import { EnvironnementProvider } from '../../core/app/environnement-provider.service';
import { AuthService } from '../../shared/services/auth.service';
import { AuthService as SecurityAuthService} from '../../shared/services/security/auth/auth.service';
// import { StaticHomeSalariePopOverPage } from '../static-home-salarie-popover/static-home-salarie-popover';

@IonicPage()
@Component({
  selector: 'page-user-temp',
  templateUrl: 'user-temp.html'
})
export class UserTempPage implements CorePage, OnInit {
  @ViewChild('popoverContent', {read: ElementRef})
  content: ElementRef;
  @ViewChild('popoverText', {read: ElementRef})
  text: ElementRef;
  public allowedMode = ['salarie'];
  public authService;
  private currentUser;
  private emailForm: FormGroup;
  private resetPasswordForm: FormGroup;
  public formErrors: any = {};
  private beneficiaire: Beneficiaire;
  private setCode = false;
  constructor(
    private popoverCtrl: PopoverController,
    private viewCtrl: ViewController,
    public navCtrl: NavController,
    public lsService: LocalStorageService,
    public oauthService: OauthService,
    private loadingService: LoadingService,
    private platformContextService: PlatformContextService,
    private pushService: PushService,
    private storage: UserStorageService,
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private beneficiaireContextService: BeneficiaireContextService,
    private beneficiairesService: BeneficiairesService,
    private toast: ToastDirective,
    public app: App,
    private lostPasswordService: LostPasswordService,
    private environnementProvider: EnvironnementProvider,
    public securityAuthService: SecurityAuthService,
  ) {
    this.authService = new AuthService(
      this.allowedMode,
      this.navCtrl,
      this.oauthService,
      this.storage
    );
    this.currentUser = this.lsService.getUser();
    this.emailForm = this.formBuilder.group({
      emailPersonnel: ['', Validators.required]
    });
    this.resetPasswordForm = this.formBuilder.group({
      code: ['', Validators.required],
      password: ['', Validators.required],
      repeatPassword: ['', Validators.required],
    });
    this.beneficiaire = this.beneficiaireContextService.get();
  }
  ionViewWillEnter() {
    this.viewCtrl.showBackButton(false); // disable back button
  }
  ionViewCanEnter() {
    return this.authService.ionViewCanEnter();
  }

  ngOnInit(): void {
    this.loadingService.end();
  }

  ionViewDidEnter() {

  }
  cancel() {
    this.oauthService.logOut(this.app);
  }
  onSubmitEmailForm() {
    if (!this.emailForm.valid) {
      return;
    }
    this.formErrors = {};
    this.loadingService.start();
    // Pas de champ additionel, cet écran n'est que pour pocket
    this.beneficiairesService.saveBeneficiaire(this.emailForm.value, this.beneficiaire.id, true)
      .subscribe(
        response => this.successHandlerEmail(response),
        error => this.errorHandlerEmail(error),
      );
  }
  onSubmitResetPasswordForm() {
    if (!this.resetPasswordForm.valid) {
      return;
    }
    this.loadingService.start();
    this.lostPasswordService.resetPassword(this.resetPasswordForm.value)
      .subscribe(
        data => {
          this.successHandlerResetPassword(data);
          // Déconnexion pour resaisir le mot de passe
          this.oauthService.logOut(this.app);
        },
        error => this.errorHandlerResetPassword(error)
      );
  }
  successHandlerResetPassword(data) {
    const siteResponse: ResponseMessage = data;
    this.loadingService.end();

    this.formErrors = {};

    this.toast.create('Votre e-mail de connexion et votre mot de passe ont été initialisés avec succès.', 3500);

  }
  successHandlerEmail(data) {
    const siteResponse: ResponseMessage = data;
    // Appel de la demande de mot de passe perdu
    const splittedClient = this.environnementProvider.default.client_id.split('_');
    splittedClient.shift();
    const client = splittedClient.join('_');
    const dataFormLostpassword = {
      email: this.emailForm.value.emailPersonnel,
      client: client
    };

    this.lostPasswordService.lostPassword(dataFormLostpassword)
      .subscribe(
        d => {
          const response: ResponseMessage = d;
          this.loadingService.end();
          this.toast.create(response.message, 3500);

          // On affiche le panneau de saisie du code
          this.setCode = true;
        },
        error => {
          if (error.hasOwnProperty('_body')) {
            const errorDecoded = JSON.parse(error._body);

            if (errorDecoded.hasOwnProperty('errors')) {
              if (errorDecoded.errors === null ) {
                return;
              }

              const response = this.messageService.handleError(error);
              this.loadingService.end();
              if (undefined !== response.formErrors) {
                  this.formErrors = response.formErrors;
              } else {
                  this.formErrors = {};
              }
            }
          }
        }
      );
  }
  errorHandlerEmail(error) {
    if (error.hasOwnProperty('_body')) {
      const errorDecoded = JSON.parse(error._body);

      if (errorDecoded.hasOwnProperty('errors')) {
        if (errorDecoded.errors === null ) {
          return;
        }

        const response = this.messageService.handleError(error);
        this.loadingService.end();
        if (undefined !== response.formErrors) {
            this.formErrors = response.formErrors;
        } else {
            this.formErrors = {};
        }
      }
    }
  }
  errorHandlerResetPassword(error) {
    if (error.hasOwnProperty('_body')) {
      const errorDecoded = JSON.parse(error._body);

      if (errorDecoded.hasOwnProperty('errors')) {
        if (errorDecoded.errors === null && (errorDecoded.message === null || errorDecoded.message === '') ) {
          return;
        }

        const response = this.messageService.handleError(error);
        this.loadingService.end();
        if (undefined !== response.formErrors) {
            this.formErrors = response.formErrors;
        } else {
            this.formErrors = {};
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/user-temp/user-temp.ts